<template>
  <div class="nav">
    <div class="content">
      <div class="mtcal">产品演示
      </div>
      <div class="text"><span style="margin-left: 15%;font-size: 14px;">业内领先的区块链全生态服务提供商</span></div>
      <div class="btnBox">
        <el-button class="btn" @click="goabout()">免费咨询</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top-picture-app.vue",
  data() {
    return {};
  },
  methods: {
    goabout() {
      this.$router.push({
        name: "about-app",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.nav {
  // min-width: 100%;
  margin-top: 70px;
  height: 190px;
  width: 100%;
  background-color: #f5f9fc;
}
.content {
  margin-top: 53px;
  width: 100%;
  height: 190px;
  background: url("../../assets/demonstration/333333.png") no-repeat center
    center;
  background-size: 100% 100%;
  // padding: 0px 5px 0px 5px;
}

.fontSize {
  //   width: 0;
    // height: 28px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2d3036;
  //   line-height: 28px;
  //   position: absolute;
  //   top: 140px;
}

.mtcal {
  //   width: 180px;
    // height: 63px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #282b31;
  //   line-height: 63px;
  margin-left: 15.5%;
  padding-top: 20px;
  padding-top: 24px;
  // position: relative;
  //   top: -110%;
}
.text {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #282B31;
  margin-top: 15px;
  font-weight: 500;
  margin-left: 30px;
}
.btnBox {
  //   margin-top: 32px;
  margin-left: 35%;
  margin-top: 20px;
}

.btn {
  width: 120px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  background: #0069fd;
  border-radius: 20px;
}
</style>
